import AmexPlatinumNightsBanner from './AmexPlatinumNightsBanner';

export default AmexPlatinumNightsBanner;
